import { render, staticRenderFns } from "./RatesTable.vue?vue&type=template&id=0001cb71"
import script from "./RatesTable.vue?vue&type=script&lang=js"
export * from "./RatesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports